import React, { Component } from 'react';

import { Icon } from 'material-ui';
import Oval from '../img/oval.svg';
const style = {
	iconContainer: {
		position: 'relative',
		height: '210px',
		display: 'flex',
		justifyContent: 'center',
		margin: '21px 0'
	},
	icon: {
		fontSize: '110px',
		position: 'absolute',
		top: 'calc(50% - 55px)',
		color: 'white',
		zIndex: '1'
	},
	ovalContainer: {
		position: 'absolute',
		backgroundImage: `url(${Oval})`,
		backgroundSize: 'contain',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat',
		width: '200px',
		height: '100%'
	},
	ovalContainer90deg: {
		transform: 'rotate(90deg)'
	},
	ovalContainer45deg: {
		transform: 'rotate(45deg)'
	},
	ovalContainer135deg: {
		transform: 'rotate(135deg)'
	}
};

export default class DemoAnimatedIcon extends Component {
	render() {
		const icon = this.props.icon || 'cloud_done';
		return (
			<div className="iconContainer" style={style.iconContainer}>
				<Icon style={style.icon}>{icon}</Icon>
				<div className="ovalContainer" style={style.ovalContainer} />
				<div
					className="ovalContainer"
					style={{ ...style.ovalContainer, ...style.ovalContainer90deg }}
				/>
				<div
					className="ovalContainer"
					style={{ ...style.ovalContainer, ...style.ovalContainer45deg }}
				/>
				<div
					className="ovalContainer"
					style={{ ...style.ovalContainer, ...style.ovalContainer135deg }}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/DemoAnimatedIcon.js